import api from '../../../../api/client'

export const GROUPING_OPTIONS = [
  { label: 'Company / Institute', value: 'institute', icon: 'business' },
  { label: 'Branch', value: 'branch', icon: 'store' },
  { label: 'Course', value: 'course', icon: 'school' },
  { label: 'Batch', value: 'batch', icon: 'group' },
  { label: 'Fee Scheme', value: 'scheme', icon: 'payments' },
  { label: 'Gender', value: 'gender', icon: 'wc' },
  { label: 'Counsellor', value: 'counsellor', icon: 'support_agent' },
  { label: 'Enquiry Source', value: 'source', icon: 'campaign' },
  { label: 'School / College', value: 'school', icon: 'apartment' },
  { label: 'Caste', value: 'caste', icon: 'badge' },
  { label: 'Sub-Caste', value: 'subcaste', icon: 'badge' },
  { label: 'City / Location', value: 'city', icon: 'location_city' },
  { label: 'Fee Status', value: 'feestatus', icon: 'account_balance_wallet' },
]

export const DATE_PERIOD_OPTIONS = [
  { value: 'period', label: 'Period' },
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'current_week', label: 'Current Week' },
  { value: 'current_month', label: 'Current Month' },
  { value: 'current_year', label: 'Current Year' },
  { value: 'last_week', label: 'Last Week' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'last_year', label: 'Last Year' },
]

export const GROUPING_EXPORT = GROUPING_OPTIONS

/**
 * Fetch live analytics data grouped by dimension from backend FastAPI.
 */
export async function getAnalyticsData(params = {}) {
  const query = {
    groupBy: params.groupBy || 'institute',
    company: params.company || 'All',
    branch: params.branch || 'All',
    course: params.course || 'All',
    batch: params.batch || 'All',
    gender: params.gender || 'All',
    counsellor: params.counsellor || 'All',
    period: params.period || params.datePeriod || 'period',
    fromDate: params.fromDate || undefined,
    toDate: params.toDate || undefined,
    tab: params.tab || 'active',
  }

  const { data } = await api.get('/admission/analytics', { params: query })
  return data || { dimension: 'institute', dimensionLabel: 'Company / Institute', totalCount: 0, items: [] }
}

/**
 * Fetch high-level overview metrics for the active filters and dimension.
 */
export async function getAnalyticsSummary(params = {}) {
  const query = {
    groupBy: params.groupBy || 'institute',
    company: params.company || 'All',
    branch: params.branch || 'All',
    course: params.course || 'All',
    batch: params.batch || 'All',
    gender: params.gender || 'All',
    counsellor: params.counsellor || 'All',
    period: params.period || params.datePeriod || 'period',
    fromDate: params.fromDate || undefined,
    toDate: params.toDate || undefined,
    tab: params.tab || 'active',
  }

  const { data } = await api.get('/admission/analytics/summary', { params: query })
  return data || {
    totalStudents: 0,
    activeSegments: 0,
    topSegmentName: '—',
    topSegmentCount: 0,
    topSegmentPercentage: 0.0,
    maleCount: 0,
    femaleCount: 0,
    otherCount: 0,
  }
}

/**
 * Fetch filter dropdown choices and supported dimensions from backend.
 */
export async function getAnalyticsOptions() {
  const { data } = await api.get('/admission/analytics/options')
  return data || {
    companies: [],
    branches: [],
    courses: [],
    batches: [],
    counsellors: [],
    academicYears: ['2026-27', '2025-26', '2024-25'],
    genders: ['All', 'Male', 'Female', 'Others'],
    dimensions: GROUPING_OPTIONS,
  }
}